var _path, _path2, _path3, _path4, _rect, _rect2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotPic2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 484,
    viewBox: "0 0 700 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M521.456 272.573C521.456 340.827 444.795 396.146 350.228 396.146C255.661 396.146 179 340.827 179 272.573C179 204.32 179 149 350.228 149C521.456 149 521.456 204.32 521.456 272.573Z",
    fill: "#000A5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M521 261.5C521 323.637 451.38 374 365.5 374C279.62 374 210 323.637 210 261.5C210 199.363 210 149 365.5 149C521 149 521 199.363 521 261.5Z",
    fill: "#003399"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M464.4 138.8C488.921 138.8 508.8 118.921 508.8 94.4C508.8 69.8786 488.921 50 464.4 50C439.879 50 420 69.8786 420 94.4C420 118.921 439.879 138.8 464.4 138.8Z",
    fill: "#003399"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M476.727 126.684C452.214 126.684 432.327 106.797 432.327 82.2838C432.327 73.0294 435.153 64.4108 440.028 57.311C427.983 65.2585 420 78.8929 420 94.3993C420 118.913 439.886 138.799 464.4 138.799C479.659 138.799 493.117 131.099 501.1 119.372C494.106 123.999 485.735 126.684 476.727 126.684Z",
    fill: "#003399"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 184,
    width: 600,
    height: 250,
    rx: 125,
    fill: "#000A5C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 184,
    width: 580,
    height: 230,
    rx: 115,
    fill: "#003399"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 302,
    r: 65,
    fill: "#F5B227"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 302,
    r: 65,
    fill: "#F5B227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotPic2);
export default __webpack_public_path__ + "static/media/BotPic2.a5a66a8c41243a0128732e9b4f666464.svg";
export { ForwardRef as ReactComponent };